import React, { useEffect, useRef, useState } from "react";
import SportsSelect from "../MainPages/SportSelect";
import './LandingPage.css';
import {
  SiNodedotjs,
  SiSlack,
  SiTwitter,
  SiReddit,
  SiIntercom,
  SiShopify,
  SiGmail,
  SiGoogleforms,
  SiSketch,
} from "react-icons/si";
import { MapPin, Trophy, Users, Calendar, ArrowRight, Play, X, Pause } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Gallery from "./Gallery";
import CricketPlayersSection from "./PlayersSection";

const ICONS = [
  { id: 1, Comp: SiNodedotjs, color: "#68A063", className: "icon-node" },
  { id: 2, Comp: SiSlack, color: "#4A154B", className: "icon-slack" },
  { id: 3, Comp: SiTwitter, color: "#1DA1F2", className: "icon-twitter" },
  { id: 4, Comp: SiReddit, color: "#FF4500", className: "icon-reddit" },
  { id: 5, Comp: SiIntercom, color: "#1F8DED", className: "icon-intercom" },
  { id: 6, Comp: SiShopify, color: "#95BF47", className: "icon-shopify" },
  { id: 7, Comp: SiGmail, color: "#D93025", className: "icon-gmail" },
  { id: 8, Comp: SiGoogleforms, color: "#673AB7", className: "icon-forms" },
  { id: 9, Comp: SiSketch, color: "#F7B500", className: "icon-sketch" },
];

const upcomingEvents = [
  {
    id: 1,
    title: "AATTUM TPL T-20 Cricket League",
    description: "AATTUM TPL T-20 Cricket League is a high-energy tournament designed to spotlight emerging cricket talent across all regions. Focused on fast-paced action, professional standards, and equal opportunity, the league provides young players a powerful platform to showcase skills, gain recognition, and advance their cricketing careers.",
    image: "/Images/image-3.png"
  },
  {
    id: 2,
    title: "AATTUM TPL Football League",
    description: "AATTUM TPL Football League is a dynamic platform created to elevate young football talent across the nation. With competitive match formats, professional coaching standards, and equal opportunities for both men and women, the league empowers emerging players to showcase their skill, passion, and potential on a bigger stage.",
    image: "/Images/image-2.png"
  },
  {
    id: 3,
    title: "AATTUM TPL Kabaddi League",
    description: "The AATTUM TPL Kabaddi League is a power-packed platform designed to promote young kabaddi talent from across the country. With high-intensity matches, professional coaching standards, and equal opportunities for men and women, the league gives rising players the perfect stage to display strength, skill, and strategy at a competitive level.",
    image: "/Images/image.png"
  },
];



// Only image sliders (use your old images)
const sliderImages = [
  "/Images/Championship.png",
  "/Images/web-poster copy.png",

];

const sliderImage = [
  "/Images/9dd921d1704c5306f2a795bf118e6ed3.jpg",
  "/Images/live-cricket-tournament-match-background-free-vector.jpg"

];

function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState("");
  const [teamType, setTeamType] = useState("");
  const [sport, setSport] = useState(null);
  const intervalRef = useRef(null);
  const extendedImages = [...sliderImages, ...sliderImages]; // duplicate
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });


  const goToSlide = (index) => {
    setCurrent(index);
  };
  // ---------------- SLIDES (ONLY ONE) ----------------
  const slides = [
    {
      league: "ATPL",
      eventName: "WOMEN'S T-20 CHAMPIONSHIP",
      monthYr: "Dec 14–21/2025",
      leftTeam: "Aattum Talent Premier League",
      rightTeam: "",
      leftLogo: "/Images/zimfg.png",
      rightLogo: "/Images/ausfg.png",
      matchLogo: "/Images/Match_logo1.png",
      leftPlayer: "/Images/web-01 copy.png",
      rightPlayer: "/Images/web-02 copy-1.png",
    },
    {
      league: "ATPL",
      eventName: "MEN'S T-20 CHAMPIONSHIP",
      monthYr: "JAN-2026",
      leftTeam: "Aattum Talent Premier League",
      rightTeam: "",
      leftLogo: "/Images/zimfg.png",
      rightLogo: "/Images/ausfg.png",
      matchLogo: "/Images/Match_logo2.png",
      leftPlayer: "/Images/zim.png",
      rightPlayer: "/Images/aus.png",
    },
  ];


  // ---------------- STATE ----------------
  const [current, setCurrent] = useState(0);
  const [animate, setAnimate] = useState(true);
  const [isStreaming, setIsStreaming] = useState(true);

  // ---------------- STREAM TOGGLE ----------------
  const toggleStream = () => {
    setIsStreaming(!isStreaming);
  };

  // ---------------- SAFE SLIDE ----------------
  const slide = slides[current] || {};

  const {
    league,
    leftTeam,
    rightTeam,
    leftLogo,
    rightLogo,
    matchLogo,
    leftPlayer,
    rightPlayer
  } = slide;

  // ---------------- ANIMATION TRIGGER ----------------
  const triggerPlayerAnimation = () => {
    const left = document.querySelector(".cricket-player-left");
    const right = document.querySelector(".cricket-player-right");
    const leftLogoEl = document.querySelector(".team-logo-left");
    const rightLogoEl = document.querySelector(".team-logo-right");

    if (!left || !right || !leftLogoEl || !rightLogoEl) return;

    [left, right, leftLogoEl, rightLogoEl].forEach(el =>
      el.classList.remove("active")
    );

    void left.offsetWidth;

    [left, right, leftLogoEl, rightLogoEl].forEach(el =>
      el.classList.add("active")
    );
  };

  useEffect(() => {
    triggerPlayerAnimation();
  }, [current]);

  // ---------------- SLIDE CHANGE ----------------
  const startAutoSlide = () => {
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      nextSlidee();
    }, 3000);
  };

  useEffect(() => {
    startAutoSlide();

    return () => clearInterval(intervalRef.current);
  }, []);

  const nextSlidee = () => {
    setAnimate(false);

    setCurrent(prev =>
      prev === slides.length - 1 ? 0 : prev + 1
    );

    setTimeout(() => setAnimate(true), 100);

    startAutoSlide(); // 🔥 reset timer
  };

  const prevSlidee = () => {
    setAnimate(false);

    setCurrent(prev =>
      prev === 0 ? slides.length - 1 : prev - 1
    );

    setTimeout(() => setAnimate(true), 100);

    startAutoSlide(); // 🔥 reset timer
  };


  useEffect(() => {
    const targetDate = new Date("April 20, 2025 00:00:00").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (difference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // FIXED EVENT CONTENT (choose slide 0 or custom data)
  const event = {
    category: "Decembar 14, 2025",
    title: "Get Ready for India’s Biggest Women’s Cricket Revolution!",
    description:
      "The AATTUM TALENT PREMIER LEAGUE (ATPL) is arriving this December 2025 in Tamil Nadu — bringing together the nation’s most fearless, talented, and unstoppable women cricketers! Witness electrifying matches, rising stars, fierce competition, and the ultimate battle for glory. This is more than cricket — it’s history in the making!",
    authorImg: "/Images/1.png",
    authorName: "Admin",
    authorRole: "Sports Coordinator",
    location: "Chennai Stadium",
  };

  const nextevent = {
    category: "Coming Soon",
    title: "AATTUM MEN’S T-20 CHAMPIONSHIP 2025",
    description:
      "The Aattum Men’s T-20 Championship brings together the finest cricketing talents from across the nation for a thrilling, high-intensity battle of skill, speed, and strategy. Featuring elite teams, electrifying match moments, and a platform built to spotlight rising stars, this tournament redefines competitive cricket with unmatched energy and professionalism.",

    authorImg: "/Images/1.png",
    authorName: "Admin",
    authorRole: "Sports Coordinator",
    location: "Chennai Stadium",
  };


  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrent((prev) => {
  //       // move to next slide
  //       return (prev + 1) % sliderImages.length; // loops from last to first
  //     });
  //   }, 3000); // 3 seconds
  //   return () => clearInterval(interval);
  // }, []);

  // Arrows
  const nextSlide = () => setCurrent((prev) => (prev + 1) % sliderImages.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);

  useEffect(() => {
    const storedSport = localStorage.getItem("sport");
    const storedUserId = localStorage.getItem("userId");
    const storedTeamType = localStorage.getItem("teamType");

    // ❗ If any value is "null", "undefined", or empty → CLEAR ALL
    if (!storedUserId || storedUserId === "null" || storedUserId === "undefined") {
      localStorage.removeItem("sport");
      localStorage.removeItem("userId");
      localStorage.removeItem("teamType");
    }

    setSport(storedSport);
    setUserId(storedUserId);
    setTeamType(storedTeamType);

    // Extract sport from URLs like /cricket-individual-form/ID
    const match = location.pathname.match(/\/(cricket|football|kabaddi|hockey|basketball|volleyball)-/);

    if (match) {
      setSport(match[1]);
    }

    // Scroll reveal observer
    const observerOptions = {
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, [location.pathname]);



  // const handleRegister = () => {
  //   window.scrollTo(0, 0);


  //   if (!sport) {
  //     alert("Sport type not found. Please start registration again.");
  //     navigate("/register");
  //     return;
  //   }

  //   if (!userId) {
  //     alert("User ID not found. Please login or start registration again.");
  //     navigate("/register");
  //     return;
  //   }

  //   if (!teamType) {
  //     const ok = window.confirm("Please select your team type (Individual / Team). Go to registration page?");
  //     if (ok) navigate("/register");
  //     return;
  //   }




  //   if (teamType === "Individual") {
  //     navigate(`/${sport}-individual-form/${userId}`);
  //   } else if (teamType === "Team") {
  //     navigate(`/${sport}-form/${userId}`);
  //   } else {
  //     alert("Invalid team type. Please try again.");
  //   }
  // };


  return (
    <>

      {/* <section className="landing-hero">

     
        <div className="landing-slideshow">
          <div className="single-slide">
            <img src="/Images/stadium1.jpeg" alt="landing" loading="eager" />
          </div>
        </div>



      
        <div className="landing-overlay"></div>

     
        <div className="landing-content">
          <h1 className="landing-title">
            AATTUM TPL
          </h1>
          <h2 className="landing-subtitle">Who we are</h2>
          <div>
            <p className="landing-description">
              AATTUM Talent Premier League is a premier multi-sports platform
              dedicated to organizing state, national, and district-level tournaments
              across Cricket, Football, Kabaddi, and Basketball for both Men & Women.
              Founded in 2022, we focus on identifying and uplifting young, talented
              athletes across India. We deliver world-class events, transparent
              selection, and a platform for rising players to showcase their skills.
              AATTUM TPL continues to empower athletes and shape a brighter sports
              future in India.
            </p>

            <button
              className="view-more-btn"
              onClick={() => navigate("/about-tpl")}
            >
              Read More
            </button>
          </div>
        </div>

      
        <div className="sports-marquee">
          <div className="sports-track">
            <span>🏏 Cricket</span>
            <span>⚽ Football</span>
            <span>🏀 Basketball</span>
            <span>🏐 Volleyball</span>
            <span>🏑 Hockey</span>
            <span>🤾‍♂️ Kabaddi</span>
            <span>🏏 Cricket</span>
            <span>⚽ Football</span>
            <span>🏀 Basketball</span>
            <span>🏐 Volleyball</span>
            <span>🏑 Hockey</span>
            <span>🤾‍♂️ Kabaddi</span>
          </div>
        </div>
      </section> */}


      <div className="cricket-section111">
        <div className="nav-wrapper">
          <div className="ticker-live-badge">LIVE</div>
          <div className="scroll-text">
            <div className="scroll-track">
              <p>
                <Trophy size={16} className="ticker-icon" /> MEN’S T-20 CHAMPIONSHIP • STREAMING LIVE NOW • JOIN THE REVOLUTION
              </p>
              <img src="/Images/Kairaa1.png" alt="Risor Sports" />
              <img src="/Images/Kairaa2.png" alt="Kairaa Academy" />
              <img src="/Images/Kairaa3.png" alt="Unikaa" />
              <img src="/Images/solarnft logo transp.png" alt="Solar NFT" />
              <img src="/Images/Activate Logo.png" alt="Activate" />
              <img src="/Images/Varma Resorts Logo.png" alt="Varma Resorts" />
              <img src="/Images/Kairaa4.png" alt="Pick Now" />
              <img src="/Images/kairaa7.png" alt="Varankal" />
            </div>
          </div>
          <button className="sponsor-apply-btn" onClick={() => navigate("/sponsor")}>
            Become a Sponsor <ArrowRight size={14} />
          </button>
        </div>

        <div className="hero-main-container">
          <div className="hero-visual-wrapper">
            <img
              key={`player-left-${current}`}
              src={leftPlayer}
              alt="Left Player"
              className={`hero-player hero-player-left ${animate ? "active" : ""}`}
            />
            <img
              key={`player-right-${current}`}
              src={rightPlayer}
              alt="Right Player"
              className={`hero-player hero-player-right ${animate ? "active" : ""}`}
            />
            {isStreaming ? (
              <div className="streaming-widget">
                <div className="stream-header">
                  {/* <span className="live-badge">LIVE</span> */}
                  <span>SpotLights</span>
                  <button className="close-stream" onClick={toggleStream}>
                    <X size={20} />
                  </button>
                </div>
                <iframe title="YouTube video player" src="https://www.youtube.com/embed/S8D2hiuV_D4?si=p_dLIBIUpO3h1mfq" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            ) : (
              <div className="vs-overlay">VS</div>
            )}
          </div>

          <div className="hero-info-overlay">
            {!isStreaming && (
              <>
                <div className="league-badge">{league}</div>
                <h1 className="hero-event-title">{slide.eventName}</h1>
                <div className="hero-event-date">
                  <Calendar size={18} /> {slide.monthYr}
                </div>

                <div className="hero-cta-group">
                  <button
                    className="cta-primary"
                    onClick={() => navigate("/register")}
                  >
                    Register Now
                  </button>
                  <button
                    className={`cta-secondary ${isStreaming ? 'active' : ''}`}
                    onClick={toggleStream}
                  >
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Play size={18} /> Watch Live
                    </span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="hero-slider-controls">
          <button className="control-btn" onClick={prevSlidee}>Prev</button>
          <div className="slider-indicator">
            {slides.map((_, i) => (
              <span key={i} className={`indicator-dot ${current === i ? 'active' : ''}`} onClick={() => setCurrent(i)} />
            ))}
          </div>
          <button className="control-btn" onClick={nextSlidee}>Next</button>
        </div>

        <div className="location-marquee">
          <div className="marquee-content">
            <MapPin size={16} /> 10 K.T.S. Garden, Tiruchirappalli, Tamil Nadu 620021 • THE HEART OF INDIAN SPORTS • JOIN THE CHAMPIONS
          </div>
        </div>
      </div>

      <section className="about-tpl-v2 reveal">
        <div className="about-v2-container">
          <div className="about-v2-image">
            <img src="/Images/AATTUM-Logo.png" alt="About TPL" />
            <div className="experience-badge">
              <span className="years">3+</span>
              <span className="text">Years of Excellence</span>
            </div>
          </div>
          <div className="about-v2-content">
            <div className="section-tag">Since 2022</div>
            <h2 className="section-title">Elevating Indian Sports Talent</h2>
            <p className="section-desc">
              Aattum TPL Sports League is a premier platform dedicated to identifying and spotlighting the nation's most promising athletic talent. We provide world-class facilities and professional league formats to bridge the gap between passion and professional sports.
            </p>
            <div className="about-features">
              <div className="feature-item">
                <Trophy size={24} />
                <div>
                  <h4>Professional Leagues</h4>
                  <p>Standardized tournament formats across India.</p>
                </div>
              </div>
              <div className="feature-item">
                <Users size={24} />
                <div>
                  <h4>Expert Coaching</h4>
                  <p>Mentorship from experienced sports professionals.</p>
                </div>
              </div>
            </div>
            <button className="cta-outline" onClick={() => navigate("/about-tpl")}>
              Our Full Story
            </button>
          </div>
        </div>
      </section>

      <div className="reveal">
        <CricketPlayersSection />
      </div>

      <section className="featured-events-v2 reveal">
        <div className="container">
          <div className="section-header-v2">
            <h2 className="title-v2">Upcoming Tournaments</h2>
            <p>Don't miss the action. Stay updated with our latest scheduled events across the country.</p>
          </div>

          <div className="events-grid-v2">
            <div className="event-card-v2 featured">
              <div className="event-v2-img">
                <img src={sliderImages[0]} alt="Event 1" />
                <div className="event-status">CURRENT</div>
              </div>
              <div className="event-v2-info">
                <span className="event-date-v2">{event.category}</span>
                <h3>{event.title}</h3>
                <p>{event.description}</p>
                <div className="event-v2-footer">
                  <Link to="/cricket-homepage" className="btn-v2 link">Match Details</Link>
                  <button className="btn-v2 primary" onClick={() => navigate("/Dec2025_Womens_T20-register")}>Register Now</button>
                </div>
              </div>
            </div>

            <div className="event-card-v2">
              <div className="event-v2-img">
                <img src={sliderImage[0]} alt="Event 2" />
                <div className="event-status upcoming">UPCOMING</div>
              </div>
              <div className="event-v2-info">
                <span className="event-date-v2">{nextevent.category}</span>
                <h3>{nextevent.title}</h3>
                <p>{nextevent.description}</p>
                <div className="event-v2-footer">
                  <button className="btn-v2 secondary" onClick={() => navigate("/Atplform")}>Register Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="reveal">
        <SportsSelect />
      </section>

      {/* ---------- ENROLL SECTION ---------- */}
      <section className="enroll-v2 reveal">
        <div className="container">
          <div className="enroll-header-v2">
            <h2 className="title-v2">Your Path to Glory</h2>
            <p>Joining the Aattum TPL revolution is simple. Follow these steps to start your professional sports journey.</p>
          </div>

          <div className="enroll-steps-v2">
            <div className="step-card-v2">
              <div className="step-num">01</div>
              <h3>Registration</h3>
              <p>Quick and easy signup process to join our elite athlete community.</p>
            </div>
            <div className="step-card-v2 active">
              <div className="step-num">02</div>
              <h3>Skill Assessment</h3>
              <p>Work with our professional coaches to identify your core strengths.</p>
            </div>
            <div className="step-card-v2">
              <div className="step-num">03</div>
              <h3>Match Day</h3>
              <p>Step onto the field and showcase your talent in national tournaments.</p>
            </div>
          </div>
        </div>
      </section>


      {/* <section className="landing-nextmatch">
        <div className="nextmatch-content">
          <h4 className="nextmatch-heading">NEXT MATCH</h4>
          <p className="nextmatch-subtitle">Champions League – 20 April, 2025</p>

          <div className="countdown">
            {Object.entries(timeLeft).map(([label, value]) => (
              <div key={label} className="countdown-box">
                <h2>{value}</h2>
                <span>{label.charAt(0).toUpperCase() + label.slice(1)}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="nextmatch-image">
          <img src="/Images/fans-cheering-soccer-final-argentina-colombia_23-2151696117.jpg" alt="Stadium" />
        </div>
      </section> */}

      {/* <section className="partners-section">
        <div className="partners-content">
          <h2>Our partners</h2>
          <p>
            Enjoy an easy and efficient experience designed to help you achieve more every day.
          </p>
         
        </div>

        <div className="partners-layout">
         
          <div className="partner-icon center-icon">
            <FaCreditCard style={{ color: "#fff", fontSize: "28px" }} />
          </div>

          
          {ICONS.map(({ id, Comp, color, className }) => (
            <div
              key={id}
              className={`partner-icon ${id === 1 || id === 2 ? "large" : id === 3 || id === 4 ? "small" : "medium"
                } ${className}`}
            >
              <Comp style={{ color }} />
            </div>
          ))}

        </div>
      </section>
      <section className="latest-events">
        <h2 className="events-title">Latest Events from TPL</h2>
        <p className="events-subtitle">
          Experience the best with seamless performance and effortless convenience in everything you do.
        </p>

        <div className="events-grid">
          {events.map((event) => (
            <div key={event.id} className="event-card fade-in">
              <img src={event.image} alt={event.title} className="event-image" />
              <span
                className="event-category"
                style={{
                  backgroundColor: event.color,
                  color: event.textColor,
                }}
              >
                {event.category}
              </span>
              <h3 className="event-title">{event.title}</h3>
              <p className="event-description">{event.description}</p>
              <div className="event-footer">
                <span className="event-author">{event.author}</span>
                <span className="event-date">{event.date}</span>
              </div>
            </div>
          ))}
        </div>
      </section> */}


      <div className="eventContainerLK reveal">
        <h2 className="mainHeadingLK">Upcoming Sports Events</h2>

        {upcomingEvents.map((event, index) => {
          // Set route based on event index
          let route = "";
          if (index === 0) route = "/cricket-homepage";
          else if (index === 1) route = "/";
          else if (index === 2) route = "/";

          return (
            <div className="eventCardLK" key={event.id}>

              {/* Left Image */}
              <div className="eventImageLK">
                <img src={event.image} alt={event.title} />
              </div>

              {/* Middle Details */}
              <div className="eventDetailsLK">
                <h2 className="eventTitleLK">{event.title}</h2>
                <div className="eventTitleLineLK"></div>
                <p className="eventTextLK">{event.description}</p>
              </div>

              {/* Right Box */}
              <div className="eventRightLK">
                <h3 className="comingTextLK">Coming Soon</h3>
                <Link to={route} className="btnLK">
                  Register & View Details
                </Link>
              </div>


            </div>
          );
        })}
      </div>

      {/* === JOIN SECTION === */}
      {/* <section className="join-section">
        <div className="join-content">
          <h1>
            Join your hands to help <br /> future generations
          </h1>
          <p>
            Join hands to shape a brighter future for the next generation — your contribution can make a lasting impact.
          </p>
          <button
            className="register-btn"
            onClick={() => {
              navigate("/register");
              window.scrollTo(0, 0); // Scrolls to top after navigation
            }}
          >
            <span>Register with us</span>
          </button>

        </div>

        <div className="join-image">
          <img
            src="https://cdn.rareblocks.xyz/collection/celebration/images/team/4/group-of-people.png"
            alt="Group of people"
          />
        </div>
      </section> */}


      {/* === SPONSOR SECTION (SEPARATE) === */}
      <section className="partners-v2 reveal">
        <div className="container">
          <div className="section-header-v2">
            <h2 className="title-v2">Official Sponsors</h2>
            <p>Supported by industry leaders who believe in the power of Indian sports talent.</p>
          </div>
          <div className="partners-grid-v2">
            <div className="partner-logo"><img src="/Images/Kairaa1.png" alt="Sponsor 1" /></div>
            <div className="partner-logo"><img src="/Images/Kairaa2.png" alt="Sponsor 2" /></div>
            <div className="partner-logo"><img src="/Images/Kairaa3.png" alt="Sponsor 3" /></div>
            <div className="partner-logo"><img src="/Images/solarnft logo transp.png" alt="Sponsor 4" /></div>
            <div className="partner-logo"><img src="/Images/Activate Logo.png" alt="Sponsor 5" /></div>
            <div className="partner-logo"><img src="/Images/Varma Resorts Logo.png" alt="Sponsor 6" /></div>
            <div className="partner-logo"><img src="https://picknow.in/assets/PicknowLogo-DKjBQdVT.png" alt="Pick Now" /></div>
            <div className="partner-logo"><img src="/Images/kairaa7.png" alt="Varankal" /></div>

          </div>
        </div>
      </section>

      <section className="landing-inspiration reveal">
        <div className="inspiration-content">
          <blockquote className="inspiration-quote">
            “People throw stones at you and you convert them into milestones.”
          </blockquote>
          <p className="inspiration-author">
            <strong>Sachin Tendulkar</strong>
            <span>Indian former international cricketer</span>
          </p>

          <div className="inspiration-cta">
            <p>Waiting for an opportunity?</p>
            <button
              className="inspiration-btn"
              onClick={() => {
                navigate("/register");
                window.scrollTo(0, 0); // Scroll to top after navigation
              }}
            >
              <span>Register with us</span>
            </button>

          </div>
        </div>

        <div className="inspiration-image">
          <img src="/Images/sac.png" alt="Sachin holding World Cup trophy" />
        </div>
      </section>
      <section className="cricket-gallery-section reveal">
        <Gallery />
      </section>
    </>
  );
}

export default LandingPage;
